import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Input, Text } from '../../components';
import { adminLogin } from '../../service';
import { toast } from 'react-toastify';

const AdminLogin = () => {
  const { t } = useTranslation();
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [emailValue, setEmailValue] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setSubmitting(true);
      setSuccess(false);
      await adminLogin({ email: emailValue });
      setError(false);
      setSuccess(true);
      toast.success(t('login.success'));
    } catch (error) {
      console.log(error);
      setError(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-white relative">
      {/* Top Color Bars */}
      <div className="flex flex-row h-6">
        <div className="bg-blue-10 w-[33.33%] h-full" />
        <div className="bg-white w-[33.33%] h-full" />
        <div className="bg-red-20 w-[33.33%] h-full" />
      </div>

      {/* Centered Content */}
      <div className="flex flex-1 flex-col justify-center items-center px-4 py-12">
        {/* Heading */}
        <h1 className="text-3xl md:text-5xl font-extrabold text-center mb-4">
          <span className="text-blue-10">{t('admin.login.heading.groupes')}</span>{' '}
          <span className="text-red-10">{t('admin.login.heading.cnat')}</span>
        </h1>
        {/* Subheading */}
        <p className="text-blue-10 text-base md:text-lg font-semibold text-center mb-10">
          {t('admin.login.subHeading')}
        </p>

        {/* Form */}
        <form
          onSubmit={handleSubmit}
          className="w-full max-w-xl flex flex-col md:flex-row gap-4 justify-center items-center">
          <div className="flex-1 w-full">
            <Input
              type="text"
              htmlType="email"
              name="email"
              id="email"
              placeholder={t('admin.login.emailPlaceholder')}
              inputClassName="!bg-gray-20 px-8 py-4 w-full h-[58px]"
              defaultValue={emailValue}
              onChange={(e) => setEmailValue(e.target.value)}
            />
          </div>
          <Button
            type={'submit'}
            text={t('admin.login.button')}
            className="w-full md:w-auto font-bold tracking-wide text-base md:text-lg px-8 py-4 h-[58px]"
            loading={submitting}
          />
        </form>
        {error && (
          <Text
            type={'xsmall'}
            text={t('login.error')}
            className={'text-center text-red-20 mt-2'}
          />
        )}
        {success && (
          <Text
            type={'xsmall'}
            text={t('login.success')}
            className={'text-center text-blue-20 mt-2'}
          />
        )}
      </div>
    </div>
  );
};

export default AdminLogin;
